import React, { useState } from 'react';
import { Button, Grid, Paper, TextField, Typography } from '@mui/material';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import toast from 'react-hot-toast';

import { Include, IncludeService } from 'us-web-services';
import DisplayService from '../../util/DisplayService';
import PageStyles from '../../styles/PageStyles';

function IncludesAdd(props: RouteComponentProps) {
  const { history } = props;
  const [label, setLabel] = useState('');
  const [type, setType] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { classes } = PageStyles();

  const addInclude = async () => {
    if (!label.trim()) {
      toast.error('Label is required');

      return;
    }

    setIsSubmitting(true);

    const includeData = {
      label: label.trim(),
      type: type.trim() || undefined,
      disabled: null,
    } as Include;

    try {
      await IncludeService.create(includeData);
      toast.success('Include successfully added');
      history.push('/includes');
    } catch (error) {
      const displayedError = DisplayService.getErrorResponse(
        error,
        'There was an error adding the include.',
      );

      toast.error(displayedError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const cancel = () => {
    history.push('/includes');
  };

  const updateLabel = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLabel(event.target.value);
  };

  const updateType = (event: React.ChangeEvent<HTMLInputElement>) => {
    setType(event.target.value);
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && !isSubmitting) {
      addInclude();
    }
  };

  return (
    <Paper className={classes.paper}>
      <Typography variant='h5' gutterBottom>
        Add Include
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            id='include-label'
            label='Label'
            variant='outlined'
            fullWidth
            required
            value={label}
            onChange={updateLabel}
            onKeyPress={handleKeyPress}
            helperText='The display label for this include (e.g., "Snacks and meals", "Transportation")'
            error={!label.trim() && label.length > 0}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='include-type'
            label='Type'
            variant='outlined'
            fullWidth
            value={type}
            onChange={updateType}
            onKeyPress={handleKeyPress}
            helperText='Optional type identifier for this include'
          />
        </Grid>
      </Grid>
      <div className={classes.buttons} style={{ marginTop: 20 }}>
        <Button
          id='cancel'
          variant='contained'
          color='secondary'
          onClick={cancel}
          disabled={isSubmitting}
          style={{ marginRight: 10 }}
        >
          Cancel
        </Button>
        <Button
          id='add-include-button'
          variant='contained'
          color='primary'
          onClick={addInclude}
          disabled={isSubmitting || !label.trim()}
        >
          {isSubmitting ? 'Adding...' : 'Add Include'}
        </Button>
      </div>
    </Paper>
  );
}

export default withRouter(IncludesAdd);
